'use client';

import { getFbCookies } from './getFbCookies';

declare global {
  interface Window {
    fbq?: (
      action: 'track' | 'trackCustom' | 'init' | 'consent',
      eventNameOrPixelId: string,
      params?: Record<string, unknown>,
      options?: { eventID?: string },
    ) => void;
  }
}

interface TrackConversionArgs {
  eventName: string;
  email?: string;
  sourceUrl?: string;
  customData?: Record<string, unknown>;
}

export async function trackConversion({
  eventName,
  email,
  sourceUrl,
  customData,
}: TrackConversionArgs): Promise<void> {
  const eventId = crypto.randomUUID();
  const { _fbp, _fbc } = getFbCookies();
  const currentUrl =
    sourceUrl || (typeof window !== 'undefined' ? window.location.href : '');

  if (typeof window !== 'undefined') {
    window.fbq?.('track', eventName, customData, { eventID: eventId });
  }

  await fetch('/api/meta-capi', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      eventName,
      eventId,
      email,
      _fbp,
      _fbc,
      sourceUrl: currentUrl,
    }),
  }).catch((err) => {
    console.error('[Meta CAPI] Failed to send server-side event:', err);
  });
}
